<!--
 * @Author: x x
 * @Date: 2024-06-26 20:42:56
 * @LastEditors: x x
 * @LastEditTime: 2024-06-26 21:30:51
 * @FilePath: \vue2-assioc-cms-admin\src\view\devise-page\right-config\components\c_competitions.vue
-->
<template>
  <div class="add-form">
    <Form ref="addForm" :model="form" :rules="diyData.rules" :label-width="100">
      <div class="tag-title">赛事</div>
      <FormItem label="是否显示" prop="status">
        <RadioGroup v-model="form.status">
          <Radio label="1">显示</Radio>
          <Radio label="2">隐藏</Radio>
        </RadioGroup>
      </FormItem>
    </Form>
    <Button type="primary" style="width: 90px; margin-right: 20px" @click="submit">保存</Button>
  </div>
</template>

<script>
import * as apiSetting from '@/api/setting'
export default {
  name: 'add-form',
  data () {
    return {
      query: {},
      search: {},
      diyDom: {},
      // 表单数据
      form: {
        status: '1'
      },
      diyData: {
        rules: {
          status: [{ required: true, message: '是否显示不能为空', trigger: 'change' }]
        }
      },
      apiData: {}
    }
  },
  computed: {},
  methods: {
    // 获取详情
    getDetail () {
      this.$store.commit('setSpinShow', true)
      apiSetting
        .apiGetSystem('competitions')
        .then(res => {
          this.form.status = res.data.status + ''
        })
        .finally(() => this.$store.commit('setSpinShow', false))
    },
    submit () {
      apiSetting
        .apiSetSystem('competitions', {
          competitions: this.form
        })
        .then(res => {
          this.$Message.success('保存成功')
          this.$bus.$emit('on-change')
          this.getDetail()
        })
    }
  },
  mounted () {
    this.getDetail()
  }
}
</script>

<style scoped lang="less">
  .add-form {
    border: 1px solid #ededed;
    margin: 0 20px;
    padding: 26px 20px;

    .title {
      border-left: 5px solid #2d8cf0;
      padding: 0 0 0 10px;
      margin: 0 20px 20px;
      font-weight: bold;
    }
  }
</style>
